function durationHours(startTime, endTime) {
  if (!startTime || !endTime) return 0;
  const parts = [startTime, endTime].flatMap((time) => time.split(":").map(Number));
  if (parts.length !== 4 || parts.some((value) => !Number.isFinite(value))) return 0;
  const [sh, sm, eh, em] = parts;
  const minutes = eh * 60 + em - sh * 60 - sm;
  return (minutes < 0 ? minutes + 1440 : minutes) / 60;
}

export function scheduleEntryHours(entry, wholeShiftHours) {
  if (entry.appliesToWholeShift) return wholeShiftHours;
  if (entry.startTime && entry.endTime) return durationHours(entry.startTime, entry.endTime);
  const hours = Number(entry.hours);
  return Number.isFinite(hours) && hours > 0 ? hours : 0;
}

export function scheduleHours(shift) {
  const fallback = String(shift.time || "").split("-").map((value) => value.trim());
  const grossHours = durationHours(shift.startTime || fallback[0], shift.endTime || fallback[1]);
  const data = shift.employeeData || shift;
  const breaks = data.breaks;
  let breakHours = Array.isArray(breaks)
    ? breaks.reduce((sum, entry) => sum + (entry.appliesToWholeShift ? 0 : scheduleEntryHours(entry, grossHours)), 0)
    : Math.max(0, Number(shift.breakMinutes || shift.break || 0) || 0) / 60;
  if (breaks?.some((entry) => entry.appliesToWholeShift)) {
    breakHours = Math.max(breakHours, grossHours >= 8 ? 1 : grossHours >= 5 ? 0.5 : 0);
  }
  const netHours = Math.max(0, grossHours - breakHours);
  const absenceHours = shift.isObemannad || shift.approvedUnstaffedPlaceholder ? 0 : Math.min(
    netHours,
    (data.absences || []).reduce((sum, entry) => sum + scheduleEntryHours(entry, netHours), 0)
  );
  return { hours: netHours - absenceHours, absenceHours, netHours };
}
